import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {AlteracoesAudit} from "./alteracoes-audit";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DatePipe, DecimalPipe} from "@angular/common";
import {ConstantsService} from "../../shared/services/constants.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-modal-alteracoes',
  templateUrl: './modal-alteracoes.component.html',
  styleUrls: ['./modal-alteracoes.component.scss']
})
export class ModalAlteracoesComponent implements OnInit, OnDestroy  {

  alteracoes: AlteracoesAudit;
  private constants = {}
  private readonly subscriptions = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) private readonly data:AlteracoesAudit,
              private readonly datePipe: DatePipe,
              private readonly decimalPipe: DecimalPipe,
              private readonly constantsService: ConstantsService) { }

  ngOnInit(): void {
    this.alteracoes = this.data;
    this.subscriptions.add(
        this.constantsService.findConstants().subscribe(data => this.constants = data));

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  isListWithExcept(value:any){
   return value !== null && value.items !== undefined && value.except !== undefined;
  }

  convertValues(value: any): string{
    if(value === null){
      return '-';
    }
    const regexDateISO = /^\d{4}-\d{2}-\d{2}$/;
    const isDate = regexDateISO.test(value)

    if(isDate){
      return this.datePipe.transform(value,'dd/MM/yyyy');
    }
    if(typeof value === "boolean" || value === 'true' || value === 'false'){
      return (Boolean(value) === true ? 'Sim' : 'Não');
    }
    if(!isNaN(+value)){
      if(value.indexOf(".") !== -1){
        return this.decimalPipe.transform(value,'1.2-2','pt');
      }
      return value;
    }
    if(typeof value === "string" && value.startsWith("[") && value.endsWith("]")){
      return JSON.parse(value).join(' / ');
    }
    if(Array.isArray(value)){
      return value.join(' / ');
    }
    const constantValue = this.constants[value.toString()];
    return constantValue === undefined ? value.toString() : constantValue;
  }

}
